import { SharedUtils } from 'sharedweb/helpers/shared.utilities';
import { StorageHelper } from './storage';
import { GlobalConfig, ToastrService } from 'ngx-toastr';
import {
    TABLE_COLUMNS,
    BATCH_SAVE_COUMNS,
    TABLE_COLUMNS_STATIC_DYANMIC_MAPPING
} from '../_shared/components/show-hide-columns/table-columns';
import { FormControl, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { LegacyDialogPosition as DialogPosition } from '@angular/material/legacy-dialog';
import { REG_EX, GMT_IST_DIFFERENCE, DATE_TIME_FORMAT_UTILITY, MOMENT_OPTION_FORMAT } from './constants';
import { OrderMode, PlatformTypeMap, UserBooks } from '../app.structs';
import { SearchSymbolResults, SortStateInterface, UserBookFiltersInterface } from 'sharedweb/app.interface';
import * as moment from 'moment';
import { SEARCH_PRECISION_COLUMNS } from '../_shared/components/show-hide-columns/table-columns';
import { PrecisionPipe } from 'sharedweb/pipes/precision/precision.pipe';
import { CustomDateTimeFormat, MarketKeywords, OrderType, OrderValidity, PositionFilter, ReverseInstrumentMapping } from 'sharedweb/app.structs';
import { DATE_TIME_FORMAT_UTILITY_II, DEFAULT_PRECISION, SECURITY_TYPE_SERIES_MAP } from 'sharedweb/helpers/shared-constants';
import { IPOList } from 'sharedweb/providers/ipo/ipo.interface';
import * as memoizee from 'memoizee';
import { DatePipe } from '@angular/common';
import { HolidayNudge, NudgeData } from '../_shared/providers/nudges/nudge-base';
import { ConfigurationService } from '../_shared/providers/configuration/configuration.service';
import { NudgeService } from '../_shared/providers/nudges/nudge.service';
import { FilterOptionsType } from '../app.interfaces';
import { GenericRequestsService } from '../_shared/providers';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MarketWatch, SymbolRow } from 'sharedweb/app.models';
import { SEARCH_SYMBOL_INSTRUMENT_TYPE } from 'sharedweb/components/add-symbol/symbol-search';
import * as enums_pb from "sharedweb/providers/utProto/enums_pb";
import { WEB_SM_ExecutionMethod, WEB_SmartOrderType } from 'sharedweb/providers/utProto/webSmartOrder_pb';

export namespace Utils {
    const precisionPipe = new PrecisionPipe();
    const datePipe = new DatePipe('en-US');

    /**
     * Utility Interface for Storage Helper Class
     */
    export const storageHelper = new StorageHelper();

    /**
     * Utility Function to Check if User Session
     * is Available.
     */
    export function isAuthenticated(): boolean {
        const userInfo = storageHelper.userInfo;
        const token = userInfo && userInfo.access_token;

        if (token) {
            return true;
        }
        return false;
    }


    /**
     * Function to Convert Snake Case identifiers to Camel Case.
     */
    export function toCamelCase(str) {
        const result = str
            .toLowerCase()
            .replace(/_([a-z])/g, function (m) {
                return m.toUpperCase();
            })
            .replace(/_/g, '');
        return result;
    }

    /**
     * Function For converting rgb to hex
     */

    export function rgbToHex(hex: string) {
        const r = parseInt(hex.substring(1, 3), 16);
        const g = parseInt(hex.substring(3, 5), 16);
        const b = parseInt(hex.substring(5, 7), 16);
        const rgb = r + ',' + g + ',' + b;
        return { r, g, b, rgb };
    }

    /**
     * Function to check if a string is json or not.
    */
    export function isJson(str: string) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false
        }
        return true;
    }

    export function applyFilter(dataSource: MatTableDataSource<any>, filterValue: string, PAGE_SIZE: number, isFiltering: boolean, showingAllData: boolean, allData: MatTableDataSource<any>) {
        // If search is empty, respect the showAllPositions setting
        if (!filterValue?.trim()) {
            dataSource.data = showingAllData ?
                [...allData.data] :
                [...allData.data].slice(0, PAGE_SIZE);
        } else {
            // When searching, show all matching results
            dataSource.data = [...allData.data];
        }
        dataSource.filter = filterValue.trim().toLowerCase();

        // Apply same filter to filteredData if filtering is active
        if (isFiltering) {
            dataSource.filter = filterValue.trim().toLowerCase();
        }
    }

    /**
     * Global Toaster Config
     */
    export const toastrConfig: Partial<GlobalConfig> = {
        timeOut: 5000,
        positionClass: 'toast-bottom-right',
        preventDuplicates: true,
        progressBar: true
    };

    /**
     *
     * @param columns:- array of column names of table
     *  Default filter searches whole table object, but this method is used to search only displayed columns.
     */
    export const filterDisplayedColumns = (columns: Array<any>, table: UserBooks) => {
        return (data: any, filter: string) => {
            let found = false;
            for (let i = 0; i < columns.length; i++) {
                const column = columns[i];

                /**
                 * RT-7202
                 * For timestamp, checking if the field to be checked
                 * is time and converting it for search
                 *
                 */
                if (column === 'modified') {
                    const dateTime = SharedUtils._convertDateTime(data[column]);
                    const timeStamp = moment(dateTime).format(DATE_TIME_FORMAT_UTILITY);
                    found = timeStamp && timeStamp.includes(filter.toLowerCase());
                } else if (column === 'symbol') {
                    found = (data['scrip_name'] && data['scrip_name'].toString().toLowerCase().includes(filter.toLowerCase())) ||
                        (data['symbol'] && data['symbol'].toString().toLowerCase().includes(filter.toLowerCase()));
                } else if (column === 'instrument_type' || column === 'instrument') {
                    found = data[column] &&
                        ReverseInstrumentMapping[data[column]].toString().toLowerCase().includes(filter.toLocaleLowerCase());
                } else if (SEARCH_PRECISION_COLUMNS[table] && SEARCH_PRECISION_COLUMNS[table].includes(column)) {
                    const precise_data = precisionPipe.transform(data[column], data.scrip_precision);
                    found = precise_data && precise_data.toString().toLowerCase().includes(filter.toLowerCase());
                } else if (column === 'childClCode') {
                    found = data['primary_client_code'] &&
                        data['primary_client_code'].toString().toLowerCase().includes(filter.toLowerCase());
                } else if (column === 'is_edis_done') {
                    filter = filter.toLowerCase();
                    const status = ('pending'.includes(filter)) ? false : ('done'.includes(filter)) ? true : null;
                    if (status !== null) {
                        found = data['is_edis_done'] === status;
                    }
                } else {
                    found = !(data[column] === undefined || data[column] === null) &&
                        data[column].toString().toLowerCase().includes(filter.toLowerCase());
                }

                if (found) {
                    break;
                }
            }
            return found;
        };
    };


    export const filterReportsDisplayedColumns = (columns: Array<string>) => {

        return (data: any, filter: string) => {
            let found = false;
            for (let i = 0; i < columns.length; i++) {
                const column = columns[i];
                if (column.toLocaleLowerCase() == 'expirydate') {
                    found = !(data[column] === undefined || data[column] === null) &&
                        data[column].toString().toLowerCase().includes(filter.toLowerCase());
                }
                else if (column.toLowerCase().includes('date')) {
                    const timeStamp = moment(data[column]).format(DATE_TIME_FORMAT_UTILITY_II);
                    found = timeStamp && timeStamp.toLowerCase().includes(filter);
                } else {
                    found = !(data[column] === undefined || data[column] === null) &&
                        data[column].toString().toLowerCase().includes(filter.toLowerCase());
                }

                if (found) {
                    break;
                }
            }
            return found;
        };
    };

    export function scrollToTop() {
        // For Edge
        document.body.scrollTop = 0;
        // For Webkit and Firefox
        document.documentElement.scrollTop = 0;
    }


    export function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    export function getDialogPosition(
        dialogsOpened: number = 2,
        width = 300,
        height = 400
    ) {
        const windowWidth =
            window.innerWidth - width > 0
                ? window.innerWidth - width
                : window.innerWidth;
        const windowHeight =
            window.innerHeight - height > 0
                ? window.innerHeight - height
                : window.innerHeight;

        if (dialogsOpened > 1) {
            const horizontalGrid =
                windowWidth < (width + 32) * dialogsOpened
                    ? windowWidth - 16
                    : (width + 32) * dialogsOpened;
            const verticalGrid =
                windowHeight < (height + 16) * dialogsOpened
                    ? windowHeight - 16
                    : (height + 16) * dialogsOpened;

            const horizontalRange = [
                windowWidth / 2 - horizontalGrid / 2,
                windowWidth / 2 + horizontalGrid / 2
            ];
            const verticalRange = [
                windowHeight / 2 - verticalGrid / 2,
                windowHeight / 2 + verticalGrid / 2
            ];

            const position: DialogPosition = {
                left:
                    Math.floor(
                        Math.random() * (horizontalRange[1] - horizontalRange[0]) +
                        horizontalRange[0]
                    ) + 'px',
                top:
                    Math.floor(
                        Math.random() * (verticalRange[1] - verticalRange[0]) +
                        verticalRange[0]
                    ) + 'px'
            };

            return position;
        }
        return null;
    }

    export function tableToCsv(tableName: string, fileName: string, data: any) {
        const csvArr: string[] = [];

        const row: string[] = [];

        Object.keys(BATCH_SAVE_COUMNS).forEach(key => {
            row.push(TABLE_COLUMNS[tableName][key]);
        });

        csvArr.push(row.join(','));

        data.forEach((item: any) => {
            const csvRow = [];

            if (item['market'] === 'ESMNSE') {
                item['market'] = 'ESM';
            }

            Object.values(BATCH_SAVE_COUMNS).forEach(value => {
                csvRow.push(item[value]);
            });

            csvArr.push(csvRow.join(','));
        });

        const csv = csvArr.join('\n');
        fileName = fileName + '.csv';

        const csvFile = new Blob([csv], { type: 'text/csv' });
        const downloadLink = document.createElement('a');

        downloadLink.download = fileName;
        downloadLink.download = fileName;
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = 'none';
        document.body.appendChild(downloadLink);
        downloadLink.click();
    }

    export function _getFromDate(resolution: string, isTradingView?: boolean) {
        const yesterday = new Date();

        if (isTradingView) {
            if (resolution.endsWith('m')) {
                yesterday.setDate(yesterday.getDate() - 1);
            } else if (resolution === '1h') {
                yesterday.setDate(yesterday.getDate() - 5);
            } else if (resolution === '1d') {
                yesterday.setMonth(yesterday.getMonth() - 1);
            } else if (resolution === '1w') {
                yesterday.setFullYear(yesterday.getFullYear() - 1);
            } else if (resolution === '1M') {
                yesterday.setFullYear(yesterday.getFullYear() - 5);
            } else {
                yesterday.setFullYear(yesterday.getFullYear() - 1);
            }
        } else {
            if (
                resolution[resolution.length - 1] === 'h' ||
                resolution[resolution.length - 1] === 'm'
            ) {
                yesterday.setDate(yesterday.getDate() - 1);
            } else if (resolution[resolution.length - 1] === 'd') {
                yesterday.setDate(yesterday.getDate() - 7);
            } else if (resolution[resolution.length - 1] === 'w') {
                yesterday.setMonth(yesterday.getMonth() - 1);
            } else {
                yesterday.setFullYear(yesterday.getFullYear() - 1);
            }
        }

        return gmtToIst(yesterday.getTime());
    }

    export function gmtToIst(time: number): string {
        return Math.ceil((time + GMT_IST_DIFFERENCE) / 1000).toString();
    }

    /**
     * Function that returns initial epoch seconds of current date.
     */
    export function getMidnightTime(): string {
        const d = new Date();
        return gmtToIst(d.setHours(0, 0, 0, 0));
    }

    export function istToGmt(time: number): number {
        return time - (GMT_IST_DIFFERENCE);
    }

    export function _getToDate() {
        const today = new Date();

        return gmtToIst(today.getTime());
    }

    /**
     * Function that return black or white contrast color according to input color
     */
    export function contrast(rgb) {
        const yiq = Math.round(
            (+rgb[0] * 299 + +rgb[1] * 587 + +rgb[2] * 114) / 1000
        );
        return yiq >= 128 ? 'black' : 'white';
    }

    /**
     * This is utility function for adding delay in code (sleeping for some time)
     *
     * @param time Time for sleeping
     * @returns Promise after awaking
     */
    export function sleep(time: number = 0) {
        return new Promise(resolve => setTimeout(resolve, time));
    }

    export function checkEsmMarket(value) {
        if (value && value === 'ESMNSE') {
            return 'ESM';
        }
        return value;
    }

    export function getPercentageChange(finalValue, initialValue) {
        return (finalValue - initialValue) / initialValue * 100;
    }

    /**
     * This utility function can be used to remove duplicates from an array of objects based an a certain parameter.
     * @param arr the array itself
     * @param comp commom parameter
     */
    export function getUnique(arr, comp) {
        const unique = arr
            .map(e => e[comp])

            // store the keys of the unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)

            // eliminate the dead keys & store unique objects
            .filter(e => arr[e])
            .map(e => arr[e]);

        return unique;
    }

    export function getFilteredData(userBook: any[], filters: UserBookFiltersInterface) {

        let filteredData = [];
        let isFirstFilter = true;

        for (const key in filters) {
            if (filters[key]) {

                // For first filter(iteration), search dataset is whole book and then filtered data of
                // each iteration will be carried forward to next iteration.
                const searchDataset = isFirstFilter ? userBook : filteredData;
                isFirstFilter = false;
                if (filters[key].includes(PositionFilter.all)) {
                    return searchDataset;
                }
                else if (filters[key].includes(PositionFilter.open)) {
                    filteredData = searchDataset.filter(val => val.netQuantity !== 0)
                }
                else if (filters[key].includes(PositionFilter.close)) {
                    filteredData = searchDataset.filter(val => val.netQuantity === 0)
                }
                if (filters[key].includes(PositionFilter.long) || filters[key].includes(PositionFilter.short)) {
                    filteredData = searchDataset.filter(val => {
                        const hasLongFilter = filters[key].includes(PositionFilter.long);
                        const hasShortFilter = filters[key].includes(PositionFilter.short);
                        const netQuantity = val.netQuantity;

                        // Case 1: Both long and short positions are selected
                        if (hasLongFilter && hasShortFilter) {
                            // Show any non-zero position (both long and short)
                            return netQuantity !== 0;
                        }

                        // Case 2: Only long positions are selected
                        if (hasLongFilter) {
                            // Show positions with positive net quantity
                            return netQuantity > 0;
                        }

                        // Case 3: Only short positions are selected
                        if (hasShortFilter) {
                            // Show positions with negative net quantity
                            return netQuantity < 0;
                        }

                    });
                }
                else if (key === 'security_type') {
                    filteredData = searchDataset.filter(holding => {
                        const holdingSeries = holding.series;
                        const matches = Object.entries(holdingSeries).some(([exchange, seriesCode]) => {
                            const isMatched = filters[key].includes(seriesCode as string);
                            return isMatched;
                        });

                        return matches;
                    });
                }
                else {
                    filteredData = searchDataset.filter((row) => {
                        return filters[key].includes(row[key]);
                    });
                }
            }
        }

        return filteredData;
    }

    export function getFormValidationErrors(control: UntypedFormGroup, toast: ToastrService) {

        Object.keys(control.controls).some((key) => {

            const controlErrors: ValidationErrors = control.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).some((keyError) => {
                    console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                    toast.error('Enter a valid ' + SharedUtils.toSentence(key));
                    return true;
                });
                return true;
            }
        });
    }

    export function createTwoWayDict(dict: Object) {
        return Object.assign(dict, ...Object.entries(dict).map(([key, value]) => ({ [value]: key })));

    }

    // Remove empty objects from an array of objects
    export function deleteEmptyObjects(rows: any[]) {
        return rows ? rows.filter((row: any) => Object.keys(row) && !Object.keys(row).length) : [];
    }

    export function sortExpiry(a, b) {
        const aExpiry = moment(a.expiry, MOMENT_OPTION_FORMAT);
        const bExpiry = moment(b.expiry, MOMENT_OPTION_FORMAT);
        if (aExpiry < bExpiry) {
            return -1;
        }
        if (aExpiry > bExpiry) {

            return 1;
        }
        return 0;
    }

    export function getStepSize(searchResult: SearchSymbolResults[]) {
        /**
                 * getting first expiry date from serach results
                 * filtering strike prices for particular expiry data and
                 * sorting them in ascending order.
                 */
        const expiryDay = searchResult[0].expiry;
        let result = searchResult.filter(el => el.expiry == expiryDay).map(r => +r.strike_price).
            filter((v, i, a) => a.indexOf(v) === i);
        result.sort(function (a, b) { return a - b });

        /**
         * finding difference between the elements in the array
         * later comparing the diff with minDiff and updating
         * minDiff accordingly
         * assigning minDiff to offset.
         */
        let minDiff = Number.MAX_SAFE_INTEGER;
        for (let i = 1; i < result.length; i++) {
            const diff = Math.abs(result[i] - result[i - 1]);
            if (diff < minDiff) {
                minDiff = diff;
            }
        }

        return minDiff;
    }

    export function applyPrecision(number, precision = DEFAULT_PRECISION) {
        if (number === undefined || number === null) {
            return undefined;
        }
        const memoizedPower = memoizee(power);
        return parseFloat(number) / memoizedPower(precision);
    }

    function power(precision: number): number {
        return Math.pow(10, precision);
    }

    export function generateFakeDepth(rows: number = 5, depth = []) {
        function createObj(depthArr: Array<string>) {
            return {
                ask: depthArr[0],
                bid: depthArr[1],
                askMktVol: depthArr[2],
                bidMktVol: depthArr[3],
                numberOfBids: depthArr[4],
                numberOfAsks: depthArr[5],
            };
        }
        for (let i = 0; i < rows; i++) {
            depth.push(createObj(['--', '--', '--', '--', '--', '--']));
        }
        return depth;
    }

    export function getNumberPrecision(scripPrecision: number = 2) {
        return `1.${scripPrecision}-${scripPrecision}`;
    }

    export function getColorClass(value: number, field?: string, coloredColumns?: string[]) {
        if (!coloredColumns || coloredColumns.includes(field)) {
            if (value > 0) {
                return 'fg-profit';
            } else if (value < 0) {
                return 'fg-loss';
            }
        }
    }

    /**
    * Custom rounding logic.
    * Rounds up if the first digit of the fractional part is 9, otherwise floors the number.
    */
    export function customRounding(resultantNumber: number, minNines: number): number {
        let result = resultantNumber;
        const fractionalPart = result.toString().split('.')[1] || '';
        // Count how many leading '9's are present in the fractional part
        let nineCount = 0;
        for (let char of fractionalPart) {
            if (char === '9') {
                nineCount++;
            } else {
                break;
            }
        }
        if (nineCount >= minNines) {
            result += (1 - parseFloat('0.' + fractionalPart));
        }

        return Math.floor(result);
    }

    // Function to convert the time string to epoch time
    export function convertTimeToEpoch(timeString: string): number {
        if (!timeString) return null;
        const momentTime = moment(timeString, CustomDateTimeFormat.time_with_seconds_capitalized);
        if (!momentTime.isValid()) return null;
        return momentTime.valueOf(); // Get time in milliseconds
    }

    // Function to convert the epoch time to formatted time string
    export function convertEpochToTimeString(epochTime: number): string {
        if (!epochTime) return null;
        return moment(epochTime * 1000).format(CustomDateTimeFormat.time_with_seconds_capitalized);
    }

    // Function to convert to 24Hour format.
    export function convertTo24HourFormat(timeString: string): string {
        const [time, modifier] = timeString.split(' ');
        let [hours, minutes, seconds = '00'] = time.split(':');
        if (modifier === 'PM' && hours !== '12') {
            hours = (parseInt(hours, 10) + 12).toString();
        } else if (modifier === 'AM' && hours === '12') {
            hours = '00';
        }
        return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
    }

    // Function to get the columns for the report download
    export function getColumnsforReportDownload(reportType: string) {
        const mapping = TABLE_COLUMNS_STATIC_DYANMIC_MAPPING[reportType];
        return Object.keys(mapping && mapping.static)
    }

    export function getPlatform(platformType: number) {
        return PlatformTypeMap[platformType];
    }

    export function preApply(element: IPOList) {
        const openTime = moment(element.open_time);
        // Check if the current moment is before the IPO open time
        if (moment().isBefore(openTime)) {
            // During the pre-apply period but before the actual open time
            return true;
        }
        // Special case for the opening day: before the exact opening time but on the opening day
        if (moment().isSame(openTime, 'day') && moment().isBefore(openTime)) {
            return true;
        }
        return false;
    }

    //handling closed case at FE same as mobile
    /**
     * This function is used to check if the IPO is closed.
     * @param time - The time to check.
     * @returns true if the IPO is closed, false otherwise.
     */
    export function isIPOClosed(time: string) {
        const closeTime = moment(time);
        const parsedClose = moment(closeTime);
        const closedTime = parsedClose.valueOf() - GMT_IST_DIFFERENCE;
        if (moment().isAfter(closedTime)) {
            return true;
        }
        return false;
    }



    export function getDateInFormat(format: string): string {
        return datePipe.transform(new Date(), format);
    }

    // Displays the holidays messages in the firebase .
    export function displayHolidayNudge(configService: ConfigurationService, nudgeService: NudgeService) {
        let date = Utils.getDateInFormat(CustomDateTimeFormat.date_only);
        if (configService.remoteConfigCacheObj.HOLIDAY_NUDGES[date]) {
            let data = configService.remoteConfigCacheObj.HOLIDAY_NUDGES[date];
            if (data['messages']) {
                data['messages'].forEach((message) => {
                    let title: string;
                    let body: string;

                    // Here we are checking if we have the title of the message we are continuing as usual and 
                    // if we dont have the title , we check if we have the message , then we interchange the message and title 
                    // and if we don't have both , we just simply return . 
                    let messageContent = Utils.checkMessage(message.title, message.body);
                    if (messageContent.length !== 0) {
                        title = messageContent[0];
                        body = messageContent[1];
                    } else {
                        return;
                    }
                    let nudge = {
                        id: 0,
                        title: title,
                        body: body,
                        icon: 'assets/icons/info-orange.svg',
                    }
                    let holidayNudge = new HolidayNudge(nudge);
                    nudgeService.addNudge(holidayNudge);
                })
            }
        }
    }

    export function saveSortState(sortState: SortStateInterface, GenericRequestsService: GenericRequestsService, key: string): void {
        const oldData: SortStateInterface = GenericRequestsService.sortingData;
        if (oldData && Object.keys(oldData).length > 0) {
            oldData[key] = sortState;
            GenericRequestsService.setSortingData(oldData).subscribe()
        } else {
            const newObj: SortStateInterface = {
                active: sortState.active,
                direction: sortState.direction
            };
            newObj[key] = sortState;
            GenericRequestsService.setSortingData(newObj).subscribe()
        }
    }

    export async function restoreSortState(GenericRequestsService: GenericRequestsService, key: string, sort: MatSort, data: any, filteredData?: any): Promise<void> {
        const savedSortState = await GenericRequestsService.getSortingData();
        if (savedSortState && savedSortState[key]) {
            const { active, direction } = savedSortState[key];
            if (sort && savedSortState) {
                sort.active = active;
                sort.direction = direction as SortDirection;
                data.sort = sort;
                filteredData.sort = sort;
            }
        }
    }

    export function checkMessage(title: string, body: string): string[] {
        // Perform some operations with title and body
        // and return an array of strings
        let messagesArray = [];
        if (title && title.length > 0) {
            messagesArray.push(title);
        }
        if (body && body.length > 0) {
            messagesArray.push(body);
        }

        // Return the array of messages
        return messagesArray;
    }

    // It will check whether we have time specific messages and based on result it will display the specified nudge .
    export function checkHolidayNudgeTime(configService: ConfigurationService, nudgeService: NudgeService,
        holidayNudgeFlag: boolean) {
        // Used to store the holidays data .
        let holidaysData = configService.remoteConfigCacheObj.HOLIDAY_NUDGES;
        if (!holidaysData) {
            return;
        }
        // Getting the current date with time 
        let currentDateTime: Date | string = new Date();
        // Extracting the date from the current date time .
        let currentDate = datePipe.transform(currentDateTime, CustomDateTimeFormat.date_only);
        // Extracting the time from the current date time .
        let time: Date | string = datePipe.transform(currentDateTime, CustomDateTimeFormat.time_only);
        // Checking if we have the timeSpecificMessages for the current date .
        let timeSpecificMessages = holidaysData[currentDate] ? holidaysData[currentDate]['timeSpecificMessages'] : null;
        // This flag will tell us that do we have to timeSpecific nudge to display or not .
        let holidayMessageFlag = false;
        if (timeSpecificMessages) {
            timeSpecificMessages.forEach((message) => {

                // Here we are checking if we have the title of the message we are continuing as usual and 
                // if we dont have the title , we check if we have the message , then we interchange the message and title 
                // and if we don't have both , we just simply return . 
                let messageContent = Utils.checkMessage(message.title, message.body);
                let title: string;
                let body: string;
                if (messageContent.length !== 0) {
                    title = messageContent[0];
                    body = messageContent[1];
                } else {
                    return;
                }
                // extracting the time from the current date and time in epoch time 
                let currentTime = Utils.dateToEpoch(currentDate + ' ' + time);
                // extracting the open time and close time from the message in epoch time
                let openTime = Utils.dateToEpoch(currentDate + ' ' + message['open']);
                let closeTime = Utils.dateToEpoch(currentDate + ' ' + message['close']);
                // if user logins within the open time and close time , the nudge will be displayed .
                if (currentTime >= openTime && currentTime <= closeTime) {
                    // If the function is called from login , we dont display timeSpecific nudge as it will be called from 
                    // the dashboard also .
                    if (!holidayNudgeFlag) {
                        Utils.displayholidayTimeMessageNudge(title, body, nudgeService);
                    }
                    holidayMessageFlag = true;
                } else if (openTime > currentTime) {
                    // If the user logins before the open time , a setTimeout will be set .
                    if (!holidayNudgeFlag) {
                        setTimeout(() => {
                            Utils.displayholidayTimeMessageNudge(title, body, nudgeService);
                        }, openTime - currentTime);
                    }
                }
            });
        }

        // If this function is called after login and there is no holidayTimeSpecificMessage displayed , displayNudge will be called.
        if (holidayNudgeFlag && !holidayMessageFlag) {
            displayHolidayNudge(configService, nudgeService);
        }
    }

    // Simply displays the time nudge message
    export function displayholidayTimeMessageNudge(title: string, body: string, nudgeService: NudgeService) {
        let nudge: NudgeData = {
            id: 0,
            title: title,
            body: body,
            icon: 'assets/icons/info-orange.svg',
        }
        let holidayNudge = new HolidayNudge(nudge);
        nudgeService.addNudge(holidayNudge);
    }

    //  Used to get epoch time of a date.
    export function dateToEpoch(date: string): number {
        let currentDate = new Date(date);
        return currentDate.getTime();
    }

    /**
    * Validates if a price string is a multiple of the specified tick size.
    * This function checks if the decimal part of a price string is divisible by the tick size.
    * For example, if tick size is 0.05, valid prices would be 100.00, 100.05, 100.10, etc.
    * @example
    * isMultipleOfTickString("100.05", 0.05, 2) // returns true
    * isMultipleOfTickString("100.07", 0.05, 2) // returns false
    * isMultipleOfTickString("100.0", 0.05, 2)  // returns true
     */
    export function isMultipleOfTickString(priceStr: string, tick: number, precision: number): boolean {
        if (!tick) return true;
        const price = String(parseFloat(priceStr)).split('.');
        if (price.length > 2) return false;
        let decimals = price[1] || '';
        if (decimals.length > precision) return false;
        const tick100 = tick * 100;
        if (decimals.length === 1) {
            return ((+decimals * 10) % tick100 === 0);
        } else if (decimals.length === 2) {
            return ((+decimals) % tick100 === 0);
        } else {
            return true; // No decimals, always valid
        }
    }

    /**
    * Rounds a price to the nearest valid tick size based on order side and field type.
    * This function implements smart rounding that considers the order context:
    * - For buy orders: targets are rounded down (cheaper), stop losses are rounded up (worse)
    * - For sell orders: targets are rounded up (more expensive), stop losses are rounded down (worse)
    * @example
    * roundToTickSize(100.07, 0.05, 2, 'buy', 'targetPrice') // returns 100.05
    * roundToTickSize(100.07, 0.05, 2, 'buy', 'stopLossPrice') // returns 100.10
    * roundToTickSize(100.07, 0.05, 2, 'sell', 'targetPrice') // returns 100.10
    */
    export function roundToTickSize(price: number, tickSize: number, precision: number, orderSide: string, fieldName: string): number {
        if (!tickSize || tickSize <= 0) {
            return Number(price.toFixed(DEFAULT_PRECISION));
        }

        // Calculate nearest tick boundaries
        const lowerTick = Math.floor(price / tickSize) * tickSize;
        const upperTick = lowerTick + tickSize;

        // Choose the "better" tick based on order side and field type
        const isBuy = orderSide === OrderMode.Buy;
        const isTarget = fieldName.includes('target');

        let result: number;

        if (isBuy) {
            // For buy orders: target should be lower (cheaper), stop loss should be higher (worse)
            result = isTarget ? lowerTick : upperTick;
        } else {
            // For sell orders: target should be higher (more expensive), stop loss should be lower (worse)
            result = isTarget ? upperTick : lowerTick;
        }

        return Number(result.toFixed(precision));
    }

    /**
    * Handles keyboard events for percentage input fields with increment/decrement functionality.
    * Supports arrow key navigation and enforces min/max boundaries.
    * @example
    * // In template: (keydown)="handlePercentKeydown($event, targetPricePercentControl, 0.01, -99.99, 100000, 2)"
    */
    export function handlePercentKeydown(event: KeyboardEvent, control: UntypedFormControl,
        percentStep: number, minPercentValue: number, maxPercentValue: number, defaultPercentValue: number): void {
        const ctrl = control;
        let value = ctrl.value;

        // Allow up/down arrow increment/decrement
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault();
            let num = parseFloat(value);
            if (isNaN(num)) num = 0;
            if (event.key === 'ArrowUp') num += percentStep;
            if (event.key === 'ArrowDown') num -= percentStep;
            // Clamp to min/max
            num = Math.max(Math.min(num, maxPercentValue), minPercentValue);
            ctrl.setValue(Number(num.toFixed(defaultPercentValue)));
        }
    }

    /**
     * Handles mouse wheel events for percentage input fields with increment/decrement functionality.
     * Supports wheel scrolling and enforces min/max boundaries. Prevents page scrolling
     * when the wheel event occurs on the input field.
     */
    export function handlePercentWheel(event: WheelEvent, control: UntypedFormControl, percentStep: number,
        minPercentValue: number, maxPercentValue: number, defaultPercentValue: number): void {
        event.preventDefault(); // Prevent page scrolling

        const ctrl = control;
        let value = ctrl.value;
        let num = parseFloat(value);

        if (isNaN(num)) num = 0;

        // Wheel up = increment, Wheel down = decrement
        if (event.deltaY < 0) {
            num += percentStep; // Wheel up
        } else {
            num -= percentStep; // Wheel down
        }
        // Clamp to min/max values
        num = Math.max(Math.min(num, maxPercentValue), minPercentValue);

        ctrl.setValue(Number(num.toFixed(defaultPercentValue)));
    }

    /**
     * Changes the current time by subtracting the specified number of days, months and years
     * @param day Number of days to subtract
     * @param month Number of months to subtract 
     * @param year Number of years to subtract
     * @returns A moment object representing the calculated date/time
     */
    export function changeTime(day: number, month: number, year: number): moment.Moment {
        return moment().subtract({
            days: day,
            months: month,
            years: year
        })
    }

    /**
    * function used to generate unique id
    */
    export function getUniqueKey(...args: (string | number)[]): string {
        return args.join('_');
    }


    // Check if the object is empty
    export function checkIfEmptyObject(obj: any) {
        return Object.keys(obj).length === 0;
    }

    /**
    * Updates filter options by extracting unique values from data array
    * @param data Array of objects to extract filter options from
    * @param mappings Object defining how to map data fields to filter options
    * @returns Object containing filter options arrays
    */
    export function updateFilterOptions(data: any[], mappings: { [key: string]: (item: any) => any }): FilterOptionsType {
        if (!data?.length) {
            return { order_mode: [], market_id: [], order_status: [], product_type: [], side: [], status: [], sip_type: [], frequency: [] };
        }
        // Create filter options by extracting unique values for each mapping
        let options = {};
        for (let [key, fn] of Object.entries(mappings)) {
            options[key] = [...new Set(data.map(fn).filter(Boolean))];
        }
        return options;
    }

    /**
     * Validates that a symbol response contains the required fields
     * @param response The symbol response object to validate
     * @returns True if the response contains valid symbol data, false otherwise
     */
    export function validateSymbolResponse(response: any): boolean {
        return response.symbol_id &&
            !isBlank(response.symbol) &&
            !isBlank(response.market_id) &&
            (response.is_index ? !isBlank(response.scrip_name) : !isBlank(response.isin));
    }

    export function isBlank(value: string): boolean {
        return value === null || value === undefined || value.trim() === '';
    }

    export function isNewSymbol(current: MarketWatch | SymbolRow, previous?: MarketWatch | SymbolRow) {
        if (!previous) return true;
        if (current instanceof MarketWatch && previous instanceof MarketWatch && current.isin && previous.isin) {
            return current.isin !== previous.isin;
        } else {
            return getUniqueKey(current?.market_id, current?.security_id) !== getUniqueKey(previous?.market_id, previous?.security_id);
        }
    }

    export function isNewSymbolForFeed(current: MarketWatch | SymbolRow, previous?: MarketWatch | SymbolRow) {
        if (!previous) return true;
        return getUniqueKey(current?.market_id, current?.security_id) !== getUniqueKey(previous?.market_id, previous?.security_id);
    }

    export function isSymbolFnO(symbol: MarketWatch) {
        return symbol.instrument_type === SEARCH_SYMBOL_INSTRUMENT_TYPE.FUTURE
            || symbol.instrument_type === SEARCH_SYMBOL_INSTRUMENT_TYPE.OPTION;
    }

    /**
    * The script is loaded here in funds page to avoid blockage at the time of inital page load. 
    * Dynamically loads the Razorpay checkout script if it's not already loaded.
    * @returns A Promise that resolves when the script is loaded successfully or rejects with an error if the script fails to load.
    */
    export function loadRazorpayScript(): Promise<void> {
        // Check if the Razorpay checkout script is already loaded
        if (document.querySelector('script[src="https://checkout.razorpay.com/v1/checkout.js"]')) {
            return Promise.resolve(); // Script is already loaded, resolve the promise
        }

        return new Promise((resolve, reject) => {
            const script = document.createElement('script'); // Create a new script element
            script.src = 'https://checkout.razorpay.com/v1/checkout.js'; // Set the source of the script
            script.onload = () => resolve(); // Resolve the promise when the script is loaded successfully
            script.onerror = () => reject(new Error('Failed to load Razorpay script')); // Reject the promise with an error if the script fails to load
            document.body.appendChild(script); // Add the script to the document body
        });
    }

    // Map market_id to exchange_id using protobuf enum
    export const getExchangeId = (marketId: string) => {
        switch (marketId) {
            case MarketKeywords.BSECM: return enums_pb.ExchangeId.EXCHANGEID_BSECM;
            case MarketKeywords.BSEFO: return enums_pb.ExchangeId.EXCHANGEID_BSEFO;
            case MarketKeywords.NSECM: return enums_pb.ExchangeId.EXCHANGEID_NSECM;
            case MarketKeywords.NSEFO: return enums_pb.ExchangeId.EXCHANGEID_NSEFO;
            case MarketKeywords.ESMNSE: return enums_pb.ExchangeId.EXCHANGEID_ESMNSE;
            case MarketKeywords.MCX: return enums_pb.ExchangeId.EXCHANGEID_MCX;
            default: return enums_pb.ExchangeId.EXCHANGEID_NSECM;
        }
    };

    // Map order type string to protobuf enum
    export const getOrderType = (orderType: string) => {
        switch (orderType?.toLowerCase()) {
            case OrderType.Limit: return enums_pb.OrderType.ORDERTYPE_LIMIT;
            case OrderType.Market: return enums_pb.OrderType.ORDERTYPE_MARKET;
            default: return enums_pb.OrderType.ORDERTYPE_LIMIT;
        }
    };

    // Map order validity string to protobuf enum
    export const getOrderValidity = (validity: string) => {
        switch (validity?.toUpperCase()) {
            case OrderValidity.day: return enums_pb.OrderValidity.ORDERVALIDITY_DAY;
            case OrderValidity.ioc: return enums_pb.OrderValidity.ORDERVALIDITY_IOC;
            default: return enums_pb.OrderValidity.ORDERVALIDITY_DAY;
        }
    };

    export const getProductType = (productType: string) => {
        switch (productType?.toLowerCase()) {
            case 'delivery': return enums_pb.ProductType.PRODUCTTYPE_DELIVERY;
            case 'intraday': return enums_pb.ProductType.PRODUCTTYPE_INTRADAY;
            case 'bracket': return enums_pb.ProductType.PRODUCTTYPE_BRACKET;
            case 'cover': return enums_pb.ProductType.PRODUCTTYPE_COVER;
            case 'carryforward': return enums_pb.ProductType.PRODUCTTYPE_CARRYFORWARD;
            case 'mtf': return enums_pb.ProductType.PRODUCTTYPE_MTF;
            default: return enums_pb.ProductType.PRODUCTTYPE_DELIVERY;
        }
    };

    export const getSmartOrderType = (orderType: string) => {

        switch (orderType?.toLowerCase()) {
            case 'twap': return WEB_SmartOrderType.SMART_ORDER_TYPE_TWAP;
            case 'pov': return WEB_SmartOrderType.SMART_ORDER_TYPE_POV;
            case 'iceberg': return WEB_SmartOrderType.SMART_ORDER_TYPE_ICEBERG;
            case 'superboco': return WEB_SmartOrderType.SMART_ORDER_TYPE_SUPER_BOCO;
            default: return WEB_SmartOrderType.SMART_ORDER_TYPE_SUPER_BOCO;
        }
    };

    export const getExecutionMethod = (executionMethod: string) => {
        switch (executionMethod?.toLowerCase()) {
            case 'best price': return WEB_SM_ExecutionMethod.EXECUTION_METHOD_BEST_PRICE;
            case 'quick fill': return WEB_SM_ExecutionMethod.EXECUTION_METHOD_QUICK_FILL;
            case 'lowest price': return WEB_SM_ExecutionMethod.EXECUTION_METHOD_LOWEST;
            case 'limit price': return WEB_SM_ExecutionMethod.EXECUTION_METHOD_LIMIT_PRICE;
            default: return WEB_SM_ExecutionMethod.EXECUTION_METHOD_BEST_PRICE;
        }
    };

    /** Parses a time string into a moment object */
    export function parseTime(time: string | Date | moment.Moment): moment.Moment | null {
        const timeFormats = [
            CustomDateTimeFormat.time_only,            // 'HH:mm:ss'
            CustomDateTimeFormat.time_only_short,      // 'h:mm a'
            CustomDateTimeFormat.time_only_short_capitalized, // 'h:mm A'
            CustomDateTimeFormat.time_with_seconds_capitalized, // 'hh:mm:ss A'
            CustomDateTimeFormat.time_24_hr_without_seconds, // 24-hour format without seconds
        ];

        let parsedTime: moment.Moment;
        if (typeof time === 'string') {
            parsedTime = moment(time, timeFormats);
            if (!parsedTime.isValid()) {
                return null;
            }
        } else if (time instanceof Date) {
            parsedTime = moment(time);
        } else if (moment.isMoment(time)) {
            parsedTime = time.clone();
        } else {
            return null;
        }

        return parsedTime;
    }

    /** Converts a time value to Unix timestamp for today's date */
    function timeToUnixTimestamp(time: string | Date | moment.Moment): number | null {
        const parsed = parseTime(time);
        if (!parsed) return null;
        
        const today = moment().startOf('day');
        return today.hours(parsed.hours()).minutes(parsed.minutes()).seconds(parsed.seconds()).unix();
    }

    /** Compares two time values, returns -1/0/1 for less/equal/greater */
    export function compareTime(time1: string | Date | moment.Moment, time2: string | Date | moment.Moment): number {
        const timestamp1 = timeToUnixTimestamp(time1);
        const timestamp2 = timeToUnixTimestamp(time2);
        
        if (timestamp1 === null || timestamp2 === null) {
            console.error('Invalid time format for compareTime');
            return -1;
        }

        return timestamp1 < timestamp2 ? -1 : timestamp1 > timestamp2 ? 1 : 0;
    }

    /** Normalizes time string by handling overflow (e.g., 90 seconds → 1:30) */
    export function normalizeTimeString(timeStr: string): string | null {
        if (typeof timeStr !== 'string') return null;
        const timeRegex = REG_EX.timeRegex;
        const match = timeStr.match(timeRegex);

        if (!match) return null;

        let hours = parseInt(match[1], 10);
        let minutes = parseInt(match[2], 10);
        let seconds = match[3] ? parseInt(match[3], 10) : 0;

        if (seconds >= 60) {
            minutes += Math.floor(seconds / 60);
            seconds %= 60;
        }

        if (minutes >= 60) {
            hours += Math.floor(minutes / 60);
            minutes %= 60;
        }
        if (match[3]) {
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        } else {
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        }
    }

    /** Adds two time values and returns result in specified format */
    export function addTime(
        time1: string | Date | moment.Moment,
        time2: string | Date | moment.Moment,
        outputFormat: string = CustomDateTimeFormat.time_only
    ): string | null {
        if (typeof time1 === 'string') {
            const normalized = normalizeTimeString(time1);
            if (normalized) time1 = normalized;
        }

        if (typeof time2 === 'string') {
            const normalized = normalizeTimeString(time2);
            if (normalized) time2 = normalized;
        }

        const timestamp1 = timeToUnixTimestamp(time1);
        const timestamp2 = timeToUnixTimestamp(time2);
        
        if (timestamp1 === null || timestamp2 === null) {
            console.error('Invalid time format for addTime');
            return null;
        }

        const todayStart = moment().startOf('day').unix();
        const totalSeconds = (timestamp1 - todayStart) + (timestamp2 - todayStart);
        const resultMoment = moment().startOf('day').add(totalSeconds, 'seconds');
        
        const totalHours = Math.floor(totalSeconds / 3600);
        const totalMinutes = Math.floor((totalSeconds % 3600) / 60);
        const remainingSeconds = totalSeconds % 60;

        if (outputFormat === CustomDateTimeFormat.time_only || outputFormat === CustomDateTimeFormat.time_24_hr_without_seconds) {
            const formattedHours = totalHours.toString().padStart(2, '0');
            const formattedMinutes = totalMinutes.toString().padStart(2, '0');

            if (outputFormat === CustomDateTimeFormat.time_only) {
                const formattedSeconds = remainingSeconds.toString().padStart(2, '0');
                return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
            } else {
                return `${formattedHours}:${formattedMinutes}`;
            }
        }

        if (totalHours >= 24) {
            const displayHours = (totalHours % 12) === 0 ? 12 : totalHours % 12;
            const amPm = totalHours % 24 < 12 ? 'AM' : 'PM';

            if (outputFormat === CustomDateTimeFormat.time_only_short ||
                outputFormat === CustomDateTimeFormat.time_only_short_capitalized) {
                return `${displayHours}:${totalMinutes.toString().padStart(2, '0')} ${amPm}`;
            } else {
                return `${displayHours.toString().padStart(2, '0')}:${totalMinutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')} ${amPm}`;
            }
        }

        return resultMoment.format(outputFormat);
    }

    /** Calculates the absolute difference between two time values in specified unit */
    export function getTimeDifference(
        time1: string | Date | moment.Moment,
        time2: string | Date | moment.Moment,
        unit: 'seconds' | 'minutes' | 'hours' = 'seconds'
    ): number | null {
        if (typeof time1 === 'string') {
            const normalized = normalizeTimeString(time1);
            if (normalized) time1 = normalized;
        }

        if (typeof time2 === 'string') {
            const normalized = normalizeTimeString(time2);
            if (normalized) time2 = normalized;
        }

        const timestamp1 = timeToUnixTimestamp(time1);
        const timestamp2 = timeToUnixTimestamp(time2);
        
        if (timestamp1 === null || timestamp2 === null) {
            console.error('Invalid time format for getTimeDifference');
            return null;
        }

        const diffSeconds = Math.abs(timestamp1 - timestamp2);

        switch (unit) {
            case 'seconds':
                return diffSeconds;
            case 'minutes':
                return Math.floor(diffSeconds / 60);
            case 'hours':
                return Math.floor(diffSeconds / 3600);
            default:
                return diffSeconds;
        }
    }

    /** Converts a time to Unix timestamp for today's date */
    export const convertTimeToUnixTimestamp = (time: string | Date | moment.Moment): number => {
        const result = timeToUnixTimestamp(time);
        return result !== null ? result : 0;
    }

}

/**
 * Functions that control the filters across all the books.
 * ********************************************************
 * *************Filter Function Start**********************
 * ********************************************************
 *
 * The list of applied filters is present in formFilter, If
 * all is selected then '-1' is sent as a result all values
 * are checked and an empty array is sent to the web server
 * as the result obtained when all values are vs when no value
 * is passed is the same.
 */
export class Filters {
    constructor() { }

    filterInstrument(formFilter, avilableInstruments, filterChecks) {
        const filters: UserBookFiltersInterface = {};
        const formValues = formFilter.getRawValue();
        if (formValues.instrumentFilter && formValues.instrumentFilter.length) {
            if (
                formValues.instrumentFilter[0] === '-1' ||
                formValues.instrumentFilter.length === avilableInstruments.length
            ) {
                const value = Object.assign([], avilableInstruments);
                filterChecks.instrumentFilterCheck = !filterChecks.instrumentFilterCheck;
                if (filterChecks.instrumentFilterCheck) {
                    value.push('-1');
                    formFilter.controls['instrumentFilter'].setValue(value, {
                        emitEvent: false
                    });
                    filters.instrument_type = value;
                } else {
                    value.pop();
                    formFilter.controls['instrumentFilter'].setValue([], {
                        emitEvent: false
                    });
                }
            } else {
                for (let i = 0; i < formValues.instrumentFilter.length; i++) {
                    if (formValues.instrumentFilter[i] === '-1') {
                        formValues.instrumentFilter.splice(i, 1);
                    }
                }
                filters.instrument_type = formValues.instrumentFilter;
            }
        }

        return filters.instrument_type;
    }

    filterQuantity(formFilter, avilableQuantity, filterChecks) {
        const filters: UserBookFiltersInterface = {};
        const formValues = formFilter.getRawValue();
        if (formValues.netQuantityFilter && formValues.netQuantityFilter.length) {
            if (
                formValues.netQuantityFilter[0] === '-1'
            ) {
                const value = Object.assign([], avilableQuantity);
                filterChecks.netQuantityFilterCheck = !filterChecks.netQuantityFilterCheck;
                if (filterChecks.netQuantityFilterCheck) {
                    value.push('-1');
                    formFilter.controls['netQuantityFilter'].setValue(value, {
                        emitEvent: false
                    });
                    filters.netQuantity = value;
                } else {
                    value.pop();
                    formFilter.controls['netQuantityFilter'].setValue([], {
                        emitEvent: false
                    });
                }
            } else {
                for (let i = 0; i < formValues.netQuantityFilter.length; i++) {
                    if (formValues.netQuantityFilter[i] === '-1') {
                        formValues.netQuantityFilter.splice(i, 1);
                    }
                    filters.netQuantity = formValues.netQuantityFilter;
                }
            }
            return filters.netQuantity;
        }
    }

    filterProduct(formFilter, avilableProductType, filterChecks) {
        const filters: UserBookFiltersInterface = {};
        const formValues = formFilter.getRawValue();
        if (formValues.productFilter && formValues.productFilter.length) {
            if (
                formValues.productFilter[0] === '-1'
            ) {
                const value = Object.assign([], avilableProductType);
                filterChecks.productFilterCheck = !filterChecks.productFilterCheck;
                if (filterChecks.productFilterCheck) {
                    value.push('-1');
                    formFilter.controls['productFilter'].setValue(value, {
                        emitEvent: false
                    });
                    filters.product_type = value;
                } else {
                    value.pop();
                    formFilter.controls['productFilter'].setValue([], {
                        emitEvent: false
                    });
                }
            } else {
                for (let i = 0; i < formValues.productFilter.length; i++) {
                    if (formValues.productFilter[i] === '-1') {
                        formValues.productFilter.splice(i, 1);
                    }
                }
                filters.product_type = formValues.productFilter;
            }
        }

        return filters.product_type;
    }

    filterOrderType(formFilter, avilableOrderType, filterChecks) {
        const filters: UserBookFiltersInterface = {};
        const formValues = formFilter.getRawValue();
        if (formValues.orderTypeFilter && formValues.orderTypeFilter.length) {
            if (
                formValues.orderTypeFilter[0] === '-1' ||
                formValues.orderTypeFilter.length === avilableOrderType.length
            ) {
                const value = Object.assign([], avilableOrderType);
                filterChecks.orderTypeFilterCheck = !filterChecks.orderTypeFilterCheck;
                if (filterChecks.orderTypeFilterCheck) {
                    value.push('-1');
                    formFilter.controls['orderTypeFilter'].setValue(value, {
                        emitEvent: false
                    });
                    filters.order_type = value;
                } else {
                    value.pop();
                    formFilter.controls['orderTypeFilter'].setValue([], {
                        emitEvent: false
                    });
                }
            } else {
                for (let i = 0; i < formValues.orderTypeFilter.length; i++) {
                    if (formValues.orderTypeFilter[i] === '-1') {
                        formValues.orderTypeFilter.splice(i, 1);
                    }
                }
                filters.order_type = formValues.orderTypeFilter;
            }
        }

        return filters.order_type;
    }

    filterOrderMode(formFilter, filterChecks) {
        const filters: UserBookFiltersInterface = {};
        const formValues = formFilter.getRawValue();
        if (formValues.orderModeFilter && formValues.orderModeFilter.length) {
            if (
                formValues.orderModeFilter[0] === '-1'
            ) {
                const value = [OrderMode['Buy'], OrderMode['Sell']];
                filterChecks.orderModeFilterCheck = !filterChecks.orderModeFilterCheck;
                if (filterChecks.orderModeFilterCheck) {
                    value.push('-1');
                    formFilter.controls['orderModeFilter'].setValue(value, {
                        emitEvent: false
                    });
                    filters.side = value;
                } else {
                    value.pop();
                    formFilter.controls['orderModeFilter'].setValue([], {
                        emitEvent: false
                    });
                }
            } else {
                for (let i = 0; i < formValues.orderModeFilter.length; i++) {
                    if (formValues.orderModeFilter[i] === '-1') {
                        formValues.orderModeFilter.splice(i, 1);
                    }
                }
                filters.side = formValues.orderModeFilter;
            }
        }

        return filters.side;
    }

    filterExchange(formFilter, availableExchanges, filterChecks) {
        const filters: UserBookFiltersInterface = {};
        const formValues = formFilter.getRawValue();

        if (formValues.segmentFilter?.length) {
            // Check if either:
            // 1. First value is '-1' (select all option) OR
            // 2. Number of selected segments equals total available exchanges
            if (formValues.segmentFilter[0] === '-1') {

                const value = Object.assign([], availableExchanges);
                // Toggling the exchange filter check state
                filterChecks.exchangeFilterCheck = !filterChecks.exchangeFilterCheck;

                if (filterChecks.exchangeFilterCheck) {
                    // If the exchange filter check is true, add '-1' to the value array
                    value.push('-1');
                    formFilter.controls['segmentFilter'].setValue(value, {
                        emitEvent: false
                    });
                    filters.market_id = value;
                } else {
                    // If the exchange filter check is false, remove '-1' from the value array
                    value.pop();
                    formFilter.controls['segmentFilter'].setValue([], {
                        emitEvent: false
                    });
                }
            } else {
                // Filter out '-1' from selected values if present
                const filteredValues = formValues.segmentFilter.filter(val => val !== '-1');
                filters.market_id = filteredValues;
            }
        }

        return filters.market_id;
    }

    filterOrderStatus(formFilter, filterChecks, orderStatusKeys) {
        const filters: UserBookFiltersInterface = {};
        const formValues = formFilter.getRawValue();
        if (formValues.orderStatusFilter && formValues.orderStatusFilter.length) {
            if (
                formValues.orderStatusFilter[0] === '-1'
            ) {
                const value = Object.assign([], orderStatusKeys);
                filterChecks.orderStatusFilterCheck = !filterChecks.orderStatusFilterCheck;
                if (filterChecks.orderStatusFilterCheck) {
                    value.push('-1');
                    formFilter.controls['orderStatusFilter'].setValue(value, {
                        emitEvent: false
                    });
                    filters.order_status = value;
                } else {
                    value.pop();
                    formFilter.controls['orderStatusFilter'].setValue([], {
                        emitEvent: false
                    });
                }
            } else {
                for (let i = 0; i < formValues.orderStatusFilter.length; i++) {
                    if (formValues.orderStatusFilter[i] === '-1') {
                        formValues.orderStatusFilter.splice(i, 1);
                    }

                    if (formValues.orderStatusFilter[i] === 'confirmed') {
                        formValues.orderStatusFilter.push('replaced');
                    }
                }
                filters.order_status = formValues.orderStatusFilter;
            }
        }

        return filters.order_status;
    }


    filterOrderCategory(formFilter, filterChecks, orderCategoryKeys) {
        const filters: UserBookFiltersInterface = {};
        const formValues = formFilter.getRawValue();
        if (formValues.orderCategoryFilter && formValues.orderCategoryFilter.length) {
            if (
                formValues.orderCategoryFilter[0] === '-1'
            ) {
                const value = Object.assign([], orderCategoryKeys);
                filterChecks.orderCategoryFilterCheck = !filterChecks.orderCategoryFilterCheck;
                if (filterChecks.orderCategoryFilterCheck) {
                    value.push('-1');
                    formFilter.controls['orderCategoryFilter'].setValue(value, {
                        emitEvent: false
                    });
                    value.pop();
                    filters.order_category = value;
                } else {
                    value.pop();
                    formFilter.controls['orderCategoryFilter'].setValue([], {
                        emitEvent: false
                    });
                }
            } else {
                for (let i = 0; i < formValues.orderCategoryFilter.length; i++) {
                    if (formValues.orderCategoryFilter[i] === '-1') {
                        formValues.orderCategoryFilter.splice(i, 1);
                    }
                }

                filters.order_category = formValues.orderCategoryFilter;
            }
        }

        return filters.order_category;
    }

    filterSecurityTypes(formFilter: UntypedFormGroup, availableSecurityTypes: string[], filterChecks: any) {
        const filters: UserBookFiltersInterface = {};
        const formValues = formFilter.getRawValue();
        const getSeriesCodes = (type: string) => {
            const bseSeries = SECURITY_TYPE_SERIES_MAP[type]['BSECM'] || [];
            const nseSeries = SECURITY_TYPE_SERIES_MAP[type]['NSECM'] || [];
            return [...bseSeries, ...nseSeries];
        };
        if (formValues.securityTypeFilter && formValues.securityTypeFilter.length) {
            if (
                formValues.securityTypeFilter[0] === '-1' ||
                formValues.securityTypeFilter.length === availableSecurityTypes.length
            ) {
                // Create a value array with all available security types
                const value = Object.assign([], availableSecurityTypes);
                filterChecks.securityTypeFilterCheck = !filterChecks.securityTypeFilterCheck;

                if (filterChecks.securityTypeFilterCheck) {
                    value.push('-1');
                    formFilter.controls['securityTypeFilter'].setValue(value, {
                        emitEvent: false
                    });
                    // Convert security types to their corresponding series codes
                    filters.security_type = value.reduce((acc, type) => {
                        if (type !== '-1') {
                            // Get all series codes for both BSECM and NSECM
                            acc.push(...getSeriesCodes(type));
                        }
                        return acc;
                    }, []);
                } else {
                    // When deselecting "All"
                    value.pop();
                    formFilter.controls['securityTypeFilter'].setValue([], {
                        emitEvent: false
                    });
                }
            } else {
                const filteredTypes = formValues.securityTypeFilter.filter(type => type !== '-1');
                // Convert selected security types to their series codes
                filters.security_type = filteredTypes.reduce((acc, type) => {
                    acc.push(...getSeriesCodes(type));
                    return acc;
                }, []);
            }
        }

        return filters.security_type;
    }

    filterSipStatus(formFilter: UntypedFormGroup, filterChecks, sipStatusKeys) {
        const filters: UserBookFiltersInterface = {};
        const formValues = formFilter.getRawValue();
        if (formValues.sipStatusFilter && formValues.sipStatusFilter.length) {
            if (formValues.sipStatusFilter[0] === '-1') {
                const value = Object.assign([], sipStatusKeys);
                filterChecks.sipStatusFilterCheck = !filterChecks.sipStatusFilterCheck;
                if (filterChecks.sipStatusFilterCheck) {
                    value.push('-1');
                    formFilter.controls['sipStatusFilter'].setValue(value, {
                        emitEvent: false
                    });
                    filters.status = value;
                } else {
                    value.pop();
                    formFilter.controls['sipStatusFilter'].setValue([], {
                        emitEvent: false
                    });
                }
            } else {
                for (let i = 0; i < formValues.sipStatusFilter.length; i++) {
                    if (formValues.sipStatusFilter[i] === '-1') {
                        formValues.sipStatusFilter.splice(i, 1);
                    }
                }
                filters.status = formValues.sipStatusFilter;
            }
        }
        return filters.status;
    }

    filterSipType(formFilter: UntypedFormGroup, filterChecks, sipTypeKeys) {
        const filters: UserBookFiltersInterface = {};
        const formValues = formFilter.getRawValue();
        if (formValues.sipTypeFilter && formValues.sipTypeFilter.length) {
            if (formValues.sipTypeFilter[0] === '-1') {
                const value = Object.assign([], sipTypeKeys);
                filterChecks.sipTypeFilterCheck = !filterChecks.sipTypeFilterCheck;
                if (filterChecks.sipTypeFilterCheck) {
                    value.push('-1');
                    formFilter.controls['sipTypeFilter'].setValue(value, {
                        emitEvent: false
                    });
                    filters.sip_type = value;
                } else {
                    value.pop();
                    formFilter.controls['sipTypeFilter'].setValue([], {
                        emitEvent: false
                    });
                }
            } else {
                for (let i = 0; i < formValues.sipTypeFilter.length; i++) {
                    if (formValues.sipTypeFilter[i] === '-1') {
                        formValues.sipTypeFilter.splice(i, 1);
                    }
                }
                filters.sip_type = formValues.sipTypeFilter;
            }
        }
        return filters.sip_type;
    }

    filterSipFrequency(formFilter: UntypedFormGroup, filterChecks, sipFrequencyKeys) {
        const filters: UserBookFiltersInterface = {};
        const formValues = formFilter.getRawValue();
        if (formValues.sipFrequencyFilter && formValues.sipFrequencyFilter.length) {
            if (formValues.sipFrequencyFilter[0] === '-1') {
                const value = Object.assign([], sipFrequencyKeys);
                filterChecks.sipFrequencyFilterCheck = !filterChecks.sipFrequencyFilterCheck;
                if (filterChecks.sipFrequencyFilterCheck) {
                    value.push('-1');
                    formFilter.controls['sipFrequencyFilter'].setValue(value, {
                        emitEvent: false
                    });
                    filters.frequency = value;
                } else {
                    value.pop();
                    formFilter.controls['sipFrequencyFilter'].setValue([], {
                        emitEvent: false
                    });
                }
            } else {
                for (let i = 0; i < formValues.sipFrequencyFilter.length; i++) {
                    if (formValues.sipFrequencyFilter[i] === '-1') {
                        formValues.sipFrequencyFilter.splice(i, 1);
                    }
                }
                filters.frequency = formValues.sipFrequencyFilter;
            }
        }
        return filters.frequency;
    }

    /**
     * Filters orders by status
     * @param formFilter The form group containing the status filter control
     * @param availableStatuses Array of available status display values
     * @param filterChecks Object containing filter check states
     * @returns Array of selected status display values or undefined if no filter applied
     */
    filterStatus(formFilter: UntypedFormGroup, availableStatuses: string[], filterChecks): string[] | undefined {
        const formValues = formFilter.getRawValue();
        if (formValues.statusFilter && formValues.statusFilter.length) {
            if (formValues.statusFilter[0] === '-1') {
                // Toggle select all behavior
                filterChecks.statusFilterCheck = !filterChecks.statusFilterCheck;
                if (filterChecks.statusFilterCheck) {
                    const value = [...availableStatuses, '-1'];
                    formFilter.controls['statusFilter'].setValue(value, { emitEvent: false });
                    return availableStatuses;
                } else {
                    formFilter.controls['statusFilter'].setValue([], { emitEvent: false });
                    return undefined;
                }
            } else {
                // Filter out any '-1' values and return selected statuses
                const selectedStatuses = formValues.statusFilter.filter((s: string) => s !== '-1');
                return selectedStatuses.length > 0 ? selectedStatuses : undefined;
            }
        }
        return undefined;
    }
    /**
     * ********************************************************
     * *************Filter Function End************************
     * ********************************************************
     */
}